import { useMemo } from 'react';

import { StatType } from 'services/stats';
import useStats from 'hooks/useStats';

import { timeFormat } from 'config/common';
import { formatDate } from 'helpers/date';

const useIndividualsChecked = (locationId) => {
  const stats = useStats(StatType.employeesChecked, {
    location_id: locationId,
  }, {
    initialStats: {
      last_update: null,
      active: 0,
      checkins: [],
      shiftInfo: {},
    },
    autoFetch: true,
    refreshInterval: 180000,
  });

  const summary = useMemo(() => {
    const { active, last_update, shiftInfo } = stats.state.stats;
    const lastUpdate = last_update ? formatDate(new Date(last_update), timeFormat, { tzOffset: 0 }) : null;
    const shiftStart = typeof shiftInfo.StartTsUTC === 'number'
      ? formatDate(shiftInfo.StartTsUTC * 1000, timeFormat, { tzOffset: shiftInfo.TzOffsetHrs })
      : '-';
    const shiftEnd = typeof shiftInfo.EndTsUTC === 'number'
      ? formatDate(shiftInfo.EndTsUTC * 1000, timeFormat, { tzOffset: shiftInfo.TzOffsetHrs })
      : '-';

    return {
      registeredIndividuals: active,
      lastUpdate,
      shiftStart,
      shiftEnd,
    };
  }, [stats.state.stats]);
  
  return {
    isLoading: stats.state.isLoading,
    summary,
    stats,
  };
};

export default useIndividualsChecked;